import React, { useState } from "react";
import { Copy, Download } from "react-feather";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";

import { Button, Col, Drawer, message, Row, Table, Tag } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { H5 } from "../../../../AbstractElements";
import { EstimatePdfOpenApi } from "../../../../api";
import {
  createEstimateDuplicate,
  fetchEstimateRevisionData,
  fetchEstimatesList,
} from "../../../../api/estimate.api";

const Inventory = (props) => {
  const [estimates, setEstimates] = React.useState([]);
  const [createdByMembers, setCreatedByMembers] = useState([]);

  const [revisionData, setRevisionData] = useState(null);
  const history = useNavigate();
  const [estimateRevisionDrawer, setEstimateRevisionDrawer] = useState(false);

  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };
  const columns = [
    {
      title: "Lead ID",
      key: "lead_id",
      dataIndex: "lead_id",
      sorter: (a, b) => {
        return a.lead_id.localeCompare(b.lead_id);
      },
      width: 160,
    },
    {
      title: "Pro Forma Invoice No.",
      key: "estimate_no",
      dataIndex: "estimate_no",
      sorter: (a, b) => {
        return a.estimate_no.localeCompare(b.estimate_no);
      },
    },
    {
      title: "Creation date",
      key: "creation_date",
      dateFormat: "MMM DD YYYY",
      sorter: (a, b) => {
        return a.created_at.localeCompare(b.created_at);
      },
      render: (data) => <>{getFormattedDate(data?.created_at)}</>,
    },
    {
      title: "Created by",
      key: "created_by__name",
      dataIndex: "created_by__name",
      filters: createdByMembers,
      onFilter: (value, record) => record.created_by__name.indexOf(value) === 0,
    },
    {
      title: "Status",
      key: "status",
      filters: [
        {
          text: "Raised",
          value: "raised",
        },
        {
          text: "Draft",
          value: "draft",
        },
      ],
      onFilter: (value, record) => record.status.indexOf(value) === 0,
      render: (data) => (
        <Tag
          style={{ textTransform: "capitalize" }}
          color={data?.status == "draft" ? "gold" : "green"}
        >
          {data.status ?? "Raised"}
        </Tag>
      ),
    },
    // {
    //   title: "Revision No.",
    //   key: "revision_no",
    //   dataIndex: "revision_no",
    // },
    {
      title: "Total",
      key: "total_estimate_amount",
      sorter: (a, b) => {
        return a.total_estimate_amount.localeCompare(b.total_estimate_amount);
      },
      render: (data) => (
        <>{parseFloat(data?.total_estimate_amount ?? 0)?.toFixed(2)}</>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      render: (data) => {
        return (
          <Row>
            <Tag
              className="mr-1"
              onClick={() => {
                // setModal2Visible(true);
                // setPoDetails(data);
                history("/app/project/estimate-details/" + data?.id);
              }}
              // color={"blue"}
              style={{ cursor: "pointer" }}
            >
              See Details
            </Tag>
            <Download
              className="mr-1"
              onClick={() => {
                // setModal2Visible(true);
                // setPoDetails(data);
                // history("/app/project/estimate-details/" + data?.id);
                window.open(EstimatePdfOpenApi + data?.id, "_blank");
              }}
            />
            <Copy
              onClick={() => {
                message.loading({
                  content: "Action in progress..",
                  duration: 30,
                  key: "duplicate",
                });
                createEstimateDuplicate(data?.id).then((res) => {
                  if (res) {
                    message.success({
                      type: "success",
                      content: "Duplicate created successfully",
                      duration: 2,
                      key: "duplicate",
                    });
                  } else {
                    message.warning({
                      type: "warning",
                      content: "Something went wrong please try again later.",
                      duration: 2,
                      key: "duplicate",
                    });
                  }
                  const projectId = props.settings?.project?.id;
                  fetchEstimatesList(projectId)
                    .then((res) => {
                      let final_data = res.map((item) => {
                        if (item.estimate?.length > 0) {
                          return { ...item, children: item.estimate };
                        } else {
                          return item;
                        }
                      });
                      setEstimates(final_data);
                    })
                    .catch(() => {
                      setEstimates([]);
                    });
                });
              }}
            />
          </Row>
        );
      },
    },
    {
      title: "See revisions",
      key: "revisions",
      render: (data) => {
        return (
          <Tag
            onClick={() => {
              setEstimateRevisionDrawer(true);
              fetchEstimateRevisionData(data.estimate_no).then((res) => {
                setRevisionData(res?.reverse());
              });
            }}
            color={"orange"}
            style={{ cursor: "pointer" }}
          >
            See Revisions
          </Tag>
        );
      },
    },
  ];

  React.useEffect(() => {
    const projectId = props.settings?.project?.id;
    fetchEstimatesList(projectId)
      .then((res) => {
        let createdByList = [];
        let final_data = res.map((item) => {
          if (
            createdByList.findIndex(
              (member) => member.text == item.created_by__name
            ) < 0
          ) {
            createdByList.push({
              text: item.created_by__name,
              value: item.created_by__name,
            });
          }
          if (item.estimate?.length > 0) {
            return { ...item, children: item.estimate };
          } else {
            return item;
          }
        });
        setEstimates(final_data);

        setCreatedByMembers(createdByList);
      })
      .catch(() => {
        setEstimates([]);
      });
  }, [props.settings?.project?.id]);

  return (
    <section>
      <Card>
        <CardBody>
          <div class="d-flex align-center">
            <H5>Inventory</H5>
          </div>
          <section className="my-2">
            <Button
              onClick={() => {
                history(`/app/project/estimates/form`, {});
              }}
              className="btn btn-primary d-flex align-items-center justify-content-center text-white"
            >
              Create Inventory
            </Button>
          </section>
          <Table
            columns={columns}
            dataSource={estimates}
            pagination={false}
            rowKey={"id"}
          />
        </CardBody>
      </Card>

      <Drawer
        title={"Pro Forma Invoice Details"}
        width={800}
        onClose={() => {
          setEstimateRevisionDrawer(false);
        }}
        visible={estimateRevisionDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        {!revisionData && <div className="mt-2">Loading...</div>}
        {revisionData?.map((data, index) => {
          return (
            <Card key={(index + Math.random())?.toString()}>
              <CardBody>
                <Row>
                  <Col sm={12} style={{ margin: "auto" }}>
                    <Col sm={24}>
                      <Col
                        style={{
                          fontSize: "12px",
                          color: "#928d8d",
                          fontWeight: "500",
                        }}
                      >
                        Lead Id{" "}
                      </Col>
                      <Col className="fw-bold" style={{ fontSize: "22px" }}>
                        {data?.lead_id}
                      </Col>
                    </Col>
                    <Col
                      sm={24}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created by{" "}
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {" "}
                        {data?.revised_by__name}{" "}
                      </span>
                    </Col>{" "}
                    <Col
                      sm={12}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created at:
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {getFormattedDate(data?.modified_at)}
                      </span>
                    </Col>{" "}
                    <Col sm={20}>
                      <Button
                        onClick={(e) => {
                          history("/app/project/estimate-details/" + data?.id);
                        }}
                        type="primary"
                        className="btn d-flex align-items-center justify-content-center border go-to-po-btn"
                      >
                        <div
                          style={{
                            marginLeft: "4px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                        >
                          See Estimate
                        </div>
                      </Button>
                    </Col>
                  </Col>
                  <Col sm={12}>
                    <div style={{ height: 42 }}></div>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Pro Forma Invoice No:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {data?.estimate_no}{" "}
                        {data?.revision && `(R${data?.revision})`}
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Status:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        <Tag
                          style={{ textTransform: "capitalize" }}
                          color={data?.status == "draft" ? "gold" : "green"}
                        >
                          {data.status ?? "Raised"}
                        </Tag>
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Total:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {Number(data?.total_estimate_amount)?.toFixed(2)}
                      </Col>
                    </Row>

                    <Row
                      style={{
                        background: "#f2f2f2",
                        padding: "2px 10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Col sm={12} className="" style={{ fontSize: "12px" }}>
                        Inclusive of all taxes
                      </Col>
                      <Col
                        sm={12}
                        className="text-right fw-bold"
                        style={{ fontSize: "25px" }}
                      >
                        {"₹"}
                        {Number(data?.total_estimate_amount)?.toFixed(2)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          );
        })}
      </Drawer>
    </section>
  );
};

const mapStateToProps = ({ dispatch, settings }) => {
  return {
    dispatch,
    settings,
  };
};

export default connect(mapStateToProps)(Inventory);
